




















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import InputControl from "@/components/Controls/InputControl.vue";
import forIn from "lodash/forIn";
import { BoolType, BoolClass } from "@/helpers/Table";
import OrganizationApi from "@/api/Organization";
import formatCurrency from "@/filters/currency";

const AppStore = namespace("App");
const _ = { forIn };

@Component({
  name: "AdminDetails",
  components: {
    InputControl
  }
})
export default class AdminDetails extends Vue {
  @Prop()
  readonly value!: [];

  @AppStore.State
  public organizations!: OrganizationList;

  public organizationFilter: string = "";

  public detailsFilter: string = "";
  public details: string | undefined = "";
  public detailsName: string = "";
  public detailsList: Array<any> = [];
  public detailsListFiltered: Array<any> = [];

  public fields: Array<BTableFieldDefinition> = [
    {
      key: "organizationName",
      label: "Organizacja",
      formatter: (value: string) => value,
      sortable: true
    },
    {
      key: "hasReport",
      label: "Raport",
      formatter: (value: any) => BoolType(value),
      tdClass: (value: any) => `report-details__has-report ${BoolClass(value)}`,
      sortable: true
    },
    {
      key: "hasReportUrl",
      label: "Link do Raportu",
      tdClass: (value: any) => `report-details__report-url ${BoolClass(value)}`,
      sortable: true
    },
    {
      key: "hasOrganizationReportUrl",
      label: "Link do Raportu Organizacji",
      tdClass: (value: any) => `report-details__report-url ${BoolClass(value)}`,
      sortable: true
    },
    {
      key: "hasList",
      label: "Lista organizacji",
      tdClass: (value: any) =>
        `report-details__has-organization-list ${BoolClass(value)}`,
      sortable: true
    }
  ];

  public fieldsDetails: Array<BTableFieldDefinition> = [
    {
      key: "name",
      label: "Organizacja",
      tdClass: "report-details__name"
    },
    {
      key: "description",
      label: "Opis",
      tdClass: "report-details__description"
    },
    {
      key: "amount",
      label: "Wartość",
      formatter: (value: number) => formatCurrency(value),
      tdClass: "report-details__amount"
    },
    {
      key: "date",
      label: "Data",
      formatter: (value: number) => formatCurrency(value),
      tdClass: "report-details__date"
    }
  ];

  get organizationList() {
    const organizations: Array<OrganizationSummary> = [];
    if (this.value?.length) {
      _.forIn(this.organizations, (v, k) => {
        const data: Array<OrganizationSummary> = this.value.filter(
          (item: OrganizationSummary) => item.organization == k
        );

        organizations.push({
          organization: k,
          organizationName: v,
          hasReportUrl: data[0]?.hasReportUrl || false,
          hasOrganizationReportUrl: data[0]?.hasOrganizationReportUrl || false,
          hasList: data[0]?.hasList === true ? "tak" : false,
          hasReport: data.length > 0
        });
      });
    }
    return organizations;
  }

  mounted() {
    this.loadDetailList();
  }

  get detailsListTotal() {
    let total = 0;
    this.detailsListFiltered.forEach(item => (total += item.amount));
    return total;
  }

  async loadDetailList(organizationId?: string, year?: number) {
    if (organizationId) {
      const organizationList = await OrganizationApi.getList(organizationId, {
        year
      }).then((res: any) => res);

      this.detailsList = organizationList;
      this.detailsName = this.organizations[organizationId];
      this.details = organizationId;
    }
  }

  unloadDetailList() {
    this.detailsList = [];
    this.detailsName = "";
    this.details = "";
  }
}
